<template>
  <header :class="`${!expanded ? 'expanded' : ''}`">
    <div class="navbar p-0">
      <div class="logo" @click="goToHome">
        <img src="/images/logos/BarLogo.png" alt="Logo" />
      </div>
      <div class="menu-toggle-wrap">
        <button class="btn menu-toggle" @click.stop="toggleSidebar">
          <i class="fa-solid fa-bars"></i>
        </button>
      </div>
      <nav :class="`menu ${expanded ? 'active' : ''}`" @click.stop>
        <!-- HOME -->
        <router-link :to="{ path: '/', hash: '#home' }" custom v-slot="{ navigate }" :class="[$route.path === '/' && $route.hash === '#home' && 'activated']">
          <a class="header-button" @click.prevent="navToHash('/', 'home')">
            <i class="fa-solid fa-house"></i>
            <span class="text orbitron-font">Home</span>
          </a>
        </router-link>
        <!-- PRODUCTS -->
        <router-link :to="{ path: '/', hash: '#products' }" custom v-slot="{ navigate }" :class="[$route.path === '/' && $route.hash === '#products' && 'activated']">
          <a class="header-button" @click.prevent="navToHash('/', 'products')">
            <i class="fa-solid fa-box-open"></i>
            <span class="text orbitron-font">Products</span>
          </a>
        </router-link>
        <!-- COMMITMENTS -->
        <router-link :to="{ path: '/', hash: '#commitments' }" custom v-slot="{ navigate }" :class="[$route.path === '/' && $route.hash === '#commitments' && 'activated']">
          <a class="header-button" @click.prevent="navToHash('/', 'commitments')">
            <i class="fa-solid fa-handshake"></i>
            <span class="text orbitron-font">Commitments</span>
          </a>
        </router-link>
        <!-- ABOUT US -->
        <router-link to="/about" class="header-button" :class="[$route.path === '/about' && 'activated']">
          <i class="fa-solid fa-eye"></i>
          <span class="text orbitron-font">About</span>
        </router-link>
        <!-- CONTACT -->
        <router-link :to="{ path: '/', hash: '#contact' }" custom v-slot="{ navigate }" :class="[$route.path === '/' && $route.hash === '#contact' && 'activated']">
          <a class="header-button" @click.prevent="navToHash('/', 'contact')">
            <i class="fa-solid fa-envelope"></i>
            <span class="text orbitron-font">Contact</span>
          </a>
        </router-link>
      </nav>
    </div>
  </header>
</template>

<script>
import { headerHeight } from '@states/HeaderState';
export default {
  name: 'NavBar',
  data() {
    return {
      isMobile: window.innerWidth <= 768,
      expanded: false,
      activeSection: 'home',
      sections: ['home', 'products', 'commitments', 'about', 'contact'],
    };
  },
  methods: {
    toggleSidebar() {
      if (this.isMobile) this.expanded = !this.expanded;
    },
    handleResize() {
      this.isMobile = window.innerWidth <= 768;
      if (!this.isMobile) this.expanded = false;
    },
    closeMenu(event) {
      if (!event.target.closest('.navbar')) this.expanded = false;
    },
    goToHome() {
      this.$router.push('/');
    },
    // Espera al elemento y scrollea con offset
    waitAndScroll(hash, maxFrames = 80) {
      function headerPx() {
        const div = document.createElement('div');
        div.style.height = headerHeight.value;
        div.style.position = 'absolute';
        div.style.visibility = 'hidden';
        document.body.appendChild(div);
        const px = div.offsetHeight;
        document.body.removeChild(div);
        return px + 25;
      }

      return new Promise((resolve) => {
        let frames = 0;
        const tryScroll = () => {
          frames++;
          const el = document.querySelector(`#${hash}`);
          if (el) {
            const hdr = headerPx();
            const elTop = el.getBoundingClientRect().top + window.scrollY;
            const target = Math.max(0, Math.round(elTop - hdr));
            window.scrollTo({ top: target, behavior: 'smooth' });
            this.expanded = false;
            return resolve(true);
          }
          if (frames < maxFrames) {
            requestAnimationFrame(tryScroll);
          } else {
            this.expanded = false;
            return resolve(false);
          }
        };
        tryScroll();
      });
    },
    // Navega a una ruta compleja -> Ruta + Sección (/#)
    async navToHash(path, hash) {
      const target = { path };
      if (hash) target.hash = `#${hash}`;
      await this.$router.push(target);
      await this.waitAndScroll(hash);
    },
    updateActiveSection() {
      if (this.$route.path !== '/') {
        this.activeSection = null;
        return;
      }
      const headerPx = (() => {
        const div = document.createElement('div');
        div.style.height = headerHeight.value;
        div.style.position = 'absolute';
        div.style.visibility = 'hidden';
        document.body.appendChild(div);
        const px = div.offsetHeight;
        document.body.removeChild(div);
        return px + 25;
      })();

      const scrollMiddle = window.scrollY + headerPx + window.innerHeight / 3;
      let found = false;

      for (const id of this.sections) {
        const el = document.getElementById(id);
        if (!el) continue;

        const top = el.offsetTop - headerPx;
        const bottom = top + el.offsetHeight;

        if (scrollMiddle >= top && scrollMiddle < bottom) {
          this.activeSection = id;
          found = true;
          break;
        }
      }

      if (!found) this.activeSection = null;
    },
  },
  mounted() {
    this.updateActiveSection();
    window.addEventListener('scroll', this.updateActiveSection);
    window.addEventListener('resize', this.handleResize);
    document.addEventListener('click', this.closeMenu);
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.updateActiveSection);
    window.removeEventListener('resize', this.handleResize);
    document.removeEventListener('click', this.closeMenu);
  },
};
</script>

<style lang="scss" scoped>
header {
  background-color: var(--Obscure-Sky);
  position: fixed;
  z-index: 100;
  top: 0;
  left: 0;
  right: 0;
  padding: 5px 20px;
  font-size: 2dvh;
  transition: 0.3s ease-out;

  .navbar {
    display: flex;
    align-items: center;
    padding: 0%;
  }

  .logo img {
    max-height: 7dvh;
    width: auto;
    object-fit: contain;
  }
  .menu-toggle-wrap {
    display: none;

    .menu-toggle {
      color: var(--Light);
      border: none;
      border-radius: 5px;
      font-size: 1.5rem;
      cursor: pointer;

      &:active {
        background-color: var(--Obscure-Sky);
      }
    }
  }

  nav.menu {
    display: flex;
    gap: 2rem;

    .header-button {
      position: relative;
      display: flex;
      align-items: center;
      text-decoration: none;
      font-size: 2dvh;
      color: var(--Light);
      transition: 0.3s ease-in-out;

      i {
        font-size: 12px;
        margin-right: 10px;
        transition: 0.3s ease-in-out;
      }

      &:hover {
        color: var(--Soft-Sky);
        &::after {
          width: 100%;
        }
      }

      &::after {
        content: '';
        position: absolute;
        left: 0;
        bottom: -4px;
        width: 15px;
        height: 2px;
        background: linear-gradient(90deg, var(--Light-Sky), var(--Midnight-Sky));
        border-radius: 999px;
        transition: width 0.25s ease-in-out;
      }

      &.activated {
        &::after {
          width: 100%;
        }

        span {
          text-shadow: 0 0 20px var(--Soft-Sky);
        }

        i {
          padding-right: 3px;
          font-size: 16px;
          color: var(--Soft-Sky);
        }
      }
    }
  }

  @media (max-width: 768px) {
    .menu-toggle-wrap {
      display: block;
    }

    nav.menu {
      display: none;
    }

    nav.menu.active {
      display: flex;
      flex-direction: column;
      position: absolute;
      top: 100%;
      left: 0;
      right: 0;
      background-color: var(--Obscure-Sky);
      border-radius: 5%;
      padding: 1rem;
      z-index: 9998;
      border: 1px solid var(--Midnight-Sky);
      border-top: none;
    }
  }
}
</style>
